(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-qh-gallery]:not([data-qh-ready])').forEach((gallery) => {
      gallery.dataset.qhReady = 'true';
      const dialog = gallery.querySelector('[data-qh-dialog]');
      if (!dialog) return;

      const openers = [...gallery.querySelectorAll('[data-qh-open]')];
      const slides = [...dialog.querySelectorAll('[data-qh-slide]')];
      const counter = dialog.querySelector('[data-qh-counter]');
      let current = 0;
      let lastTrigger;
      let touchStartX = null;

      const show = (index) => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== current; });
        if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      };

      const open = (index, trigger) => {
        lastTrigger = trigger;
        show(index);
        if (typeof dialog.showModal === 'function') dialog.showModal();
      };

      openers.forEach((button, index) => button.addEventListener('click', () => open(index, button)));
      dialog.querySelector('[data-qh-close]')?.addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-qh-prev]')?.addEventListener('click', () => show(current - 1));
      dialog.querySelector('[data-qh-next]')?.addEventListener('click', () => show(current + 1));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => lastTrigger?.focus());
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
      dialog.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
      dialog.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        if (Math.abs(distance) > 50) show(current + (distance < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
